import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, HtmlContent, Button } from './ui';

const StyledContent = styled.section`
  ${({ isBlogSingle }) =>
    isBlogSingle ? sectionMargins('30px', '50px') : sectionMargins()}
`;

const StyledButtonWrapper = styled.div`
  text-align: center;
`;

const StyledButton = styled(Button)`
  margin-top: 15px;

  ${minBreakpointQuery.small`
    margin-top: 20px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 25px;
  `}
`;

const Content = ({ html, link, isBlogSingle }) =>
  html && (
    <StyledContent isBlogSingle={isBlogSingle}>
      <Container narrow={isBlogSingle}>
        <HtmlContent html={html} />
        {link && (
          <StyledButtonWrapper>
            <StyledButton to={link.page.slug} linkData={link.page}>
              {link.text}
            </StyledButton>
          </StyledButtonWrapper>
        )}
      </Container>
    </StyledContent>
  );

export default Content;
